import _ from "lodash";

import { Box } from "@chakra-ui/react";

import FilterForm from "../../components/FilterForm";
import { useSelector } from "react-redux";
import AgentsTable from "../../components/branches/tables/AgentsTable";
import Loader from "../../components/loader";
import { getReportDescription } from "../../store/helpers";

const TicketsPerAgents = ({ showFilterForm = true, reportIndex = 1 }) => {
  const { tickets, branches, organizationId, loading, reportRange, branchId } =
    useSelector((state) => state.defaultReducer);
  const ticketsClone = _.cloneDeep(tickets);
  const branchesClone = _.cloneDeep(branches);
  const orgBranches = branchesClone
    .filter(
      (branch) =>
        branch.organizationId === organizationId && Number(branch.reportStatus)
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));

  //separate the data into branches
  const branchesMap = orgBranches.reduce((acc, branch) => {
    acc[branch.id] = [];
    return acc;
  }, {});

  ticketsClone.forEach((data) => {
    const branchId = data.branchId;

    if (Array.isArray(branchesMap[branchId])) {
      branchesMap[branchId].push(data);
    }
  });

  const title = `${reportIndex || ""}. Tickets Per Agent`;
  console.log(title);

  return (
    <Box>
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <h1>{title}</h1>
              <p>{getReportDescription(reportRange).TicketsByAgents}</p>

              {Object.keys(branchesMap).map((branchId, index) => {
                return (
                  <AgentsTable
                    branchIndex={index}
                    data={branchesMap[branchId]}
                    branchId={branchId}
                    reportIndex={reportIndex}
                  />
                );
              })}
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default TicketsPerAgents;
